import { Box, Paper, SxProps, TableCell, TableRow, Theme, Typography } from '@mui/material';
import { Row } from 'react-table';
import { DollarCell } from 'shared/tables/DollarCell';
import { PercentCell } from 'shared/tables/PercentCell';
import { ColumnsQuoteLineTable } from 'shared/types/quoteline';

const discountsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  width: '100%',
  padding: '0 15% 0 15%',
};
const discountPaperStyles: SxProps<Theme> = {
  marginLeft: '5px',
  marginTop: '5px',
  height: 100,
  width: 200,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};
const summaryStyles: SxProps<Theme> = {
  marginTop: '35px',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};
const redStyles: SxProps<Theme> = { color: '#f08b1d' };
const greenStyles: SxProps<Theme> = { color: '#004489' };
const yellowStyles: SxProps<Theme> = { color: '#f08b1d' };
const descriptionStyles: SxProps<Theme> = { maxWidth: '80%', textAlign: 'center' };

interface QuoteLineExpansionProps {
  row: Row<ColumnsQuoteLineTable>;
}

export const QuoteLineExpansion = ({ row }: QuoteLineExpansionProps) => {
  const { adjustedExtendedPrice, lineExtendedCost } = row.original;

  const adjustedMargin = lineExtendedCost ? (adjustedExtendedPrice - lineExtendedCost || 0) / adjustedExtendedPrice : 0;
  return (
    <TableRow>
      <TableCell colSpan={9}>
        <Box sx={discountsContainerStyles}>
          <Paper sx={discountPaperStyles}>
            <Typography variant='h4' sx={redStyles}>
              <PercentCell value={row.original.minDiscount ?? 0} />
            </Typography>
            <Typography variant='body1' gutterBottom component='div' sx={descriptionStyles}>
              Minimum Peer Historical
            </Typography>
          </Paper>
          <Paper sx={discountPaperStyles}>
            <Typography variant='h4' sx={greenStyles}>
              <PercentCell value={row.original.recommendedDiscount ?? 0} />
            </Typography>
            <Typography variant='body1' gutterBottom component='div' sx={descriptionStyles}>
              Maximum Allowable Discount
            </Typography>
          </Paper>
          <Paper sx={discountPaperStyles}>
            <Typography variant='h4' sx={yellowStyles}>
              <PercentCell value={row.original.maxDiscount ?? 0} />
            </Typography>
            <Typography variant='body1' gutterBottom component='div' sx={descriptionStyles}>
              Maximum Peer Historical
            </Typography>
          </Paper>
        </Box>
        <Box sx={discountsContainerStyles}>
          <Box sx={summaryStyles}>
            <Typography variant='h5'>
              <DollarCell value={row.original.adjustedExtendedPrice} />
            </Typography>
            <Typography variant='body1' gutterBottom component='div'>
              Revenue at New Price
            </Typography>
          </Box>
          <Box sx={summaryStyles}>
            <Typography variant='h5'>
              <DollarCell value={row.original.adjustedExtendedPrice / row.original.quantity} />
            </Typography>
            <Typography variant='body1' gutterBottom component='div'>
              Discounted Price
            </Typography>
          </Box>
          <Box sx={summaryStyles}>
            <Typography variant='h5'>{adjustedMargin ? <PercentCell value={adjustedMargin} /> : ''}</Typography>
            <Typography variant='body1' gutterBottom component='div'>
              Discounted Margin
            </Typography>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};
